import getValidationError from '@assetsJsModule/dropzone/service/getValidationError';

import {
    maxNumberOfFiles, maxTotalFilesSize, allowedMimeTypes, VALIDATION_SCHEMA, RULES
} from '../config/constants';

const validateField = (value, rules) => {
    for (const { rule, value: ruleValue } of rules) {
        const validator = RULES[rule];

        if (!validator) {
            continue;
        }

        const error = validator(value, ruleValue);

        if (error) {
            return error;
        }
    }

    return null;
};

export const validate = (values, props) => {
    const { t } = props;
    const errors = {};

    Object.entries(VALIDATION_SCHEMA).forEach(([fieldName, rules]) => {
        const errorKey = validateField(values[fieldName], rules);

        if (errorKey) {
            errors[fieldName] = t(errorKey);
        }
    });

    const attachmentError = getValidationError(
        values.attachments || [],
        maxNumberOfFiles,
        maxTotalFilesSize,
        allowedMimeTypes,
    );

    if (attachmentError) {
        errors.attachments = attachmentError;
    }

    return errors;
};
